import React, { useCallback } from 'react';
//import { motion } from 'framer-motion';
import { Box } from '@mui/material';
import Particles from 'react-particles';
import { loadSlim } from 'tsparticles-slim';
import HeroSection from './HeroSection';
import Philosophy from './Philosophy';
import Services from './Services';
import ClientLogos from './ClientLogos';
import ContactForm from './ContactForm';
import './Home.css';

const Home = () => {
  const particlesInit = useCallback(async engine => {
    await loadSlim(engine);
  }, []);

  return (
    <Box className="home-container">
      <Particles
        id="tsparticles"
        init={particlesInit}
        options={{
          background: {
            color: {
              value: "transparent",
            },
          },
          fpsLimit: 120,
          interactivity: {
            events: {
              onHover: {
                enable: true,
                mode: "grab",
              },
              resize: true,
            },
            modes: {
              grab: {
                distance: 140,
                line_linked: {
                  opacity: 0.4
                }
              },
            },
          },
          particles: {
            color: {
              value: ["#51A8B1", "#A8CF45"],
            },
            links: {
              color: "#51A8B1",
              distance: 150,
              enable: true,
              opacity: 0.38,
              width: 1,
            },
            move: {
              direction: "none",
              enable: true,
              outModes: {
                default: "bounce",
              },
              random: false,
              speed: 1,
              straight: false,
            },
            number: {
              density: {
                enable: true,
                area: 800,
              },
              value: 80,
            },
            opacity: {
              value: 0.5,
            },
            shape: {
              type: "circle",
            },
            size: {
              value: { min: 1, max: 3 },
            },
          },
          detectRetina: true,
        }}
      />
      
      <HeroSection />
      <Philosophy />
      <Services />
      <ClientLogos />
      <ContactForm />
    </Box>
  );
};

export default Home;